<template>
<div class="chapter">
<div class="inner_page">
<div class="toc" id="toc">
<h1 class="toc">CONTENTS</h1>
<p class="center"><a class="hlink" href="#/9780312375942_epub_ack_r1.htm"><em>Acknowledgments</em></a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_itr_r1.htm">Introduction</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c01_r1.htm">1. Between the Reformation and a New Alliance (1566–1570)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c02_r1.htm">2. Dark Years (1570–1587)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c03_r1.htm">3. Times of Action (1587–1605)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c04_r1.htm">4. New Horizons (1605–1644)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c05_r1.htm">5. Era of Expansion (1644–1691)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c06_r1.htm">6. Time of Intrigue (1691–1721)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c07_r1.htm">7. Some Brief Reigns (1721–1775)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c08_r1.htm">8. The Rise and Fall of Eagles (1775–1823)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c09_r1.htm">9. An Era of Spies (1823–1878)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c10_r1.htm">10. The League of the Impious (1878–1914)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c11_r1.htm">11. The Horseman of the Apocalypse (1914–1917)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c12_r1.htm">12. Intriguing Toward Peace (1917–1922)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c13_r1.htm">13. Era of the Dictators (1922–1934)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c14_r1.htm">14. Rise of the Terror (1934–1940)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c15_r1.htm">15. The End of the Thousand-Year Reich (1940–1945)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c16_r1.htm">16. “Odessa” and the “Vatican Ratline” (1946–1958)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c17_r1.htm">17. New Alliances (1958–1976)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c18_r1.htm">18. “Vatican, Inc.” and God’s Business (1976–1978)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c19_r1.htm">19. Time of the Assassins (1979–1982)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_c20_r1.htm">20. The Polish Years (1982–2005)</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_epl_r1.htm">Epilogue: The Years to Come: Benedict XVI</a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_app_r1.htm"><em>Appendix: List of Popes Since the Creation of the Holy Alliance</em></a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_nts_r1.htm"><em>Notes</em></a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_bib_r1.htm"><em>Bibliography</em></a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_bm_r1.htm"><em>Archives Consulted</em></a></p>
<p class="center"><a class="hlink" href="#/9780312375942_epub_ind_r1.htm"><em>Index</em></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780312375942_epub_toc_r1.vue?4661f014